import React from "react";
import image from "./../../Assets/Media/Domain Appraisal.png";
import "./ExploreCard.css";
import { TiTick } from "react-icons/ti";
import { Link } from "react-router-dom";

const ExploreCard = () => {
  return (
    <div className="flex justify-between items-center w-full gap-5 lg:mt-0 explore-section ">
      <div className="container a-container a-padding !pt-[80px]">
        <div className="flex explore-inner-div">
          <div className=" w-full xl:w-[53%] lg:mb-0 lg:!text-left explore-content">
            <h3 className="text-4xl font-bold !text-[45px] text-[#fbcb04] my-4 title !text-left">
              <span className="text-pent">Domain Value </span> Appraisal
            </h3>
            <h3 className=" font-bold !text-[18px] second-head !text-left">
              Unlock Your{" "}
              <span className="text-pent"> .GOLD DOMAIN&apos;s </span>
              True Worth
            </h3>
            <hr className="!w-full" />
            <h2 className="font-medium leading-normal paragraph !normal-case mt-[20px]">
              Every domain is unique, and we have the expertise to determine its
              real value. Our professional appraisals, backed by data-driven
              methods, cover both individual domains and entire portfolios.
            </h2>

            <div className="flex flex-wrap md:ml-0 items-center gap-[20px] mt-[20px] explore-ul">
              <p className="flex flex-col md:flex-row content-start md:items-center gap-1 sub-headd">
                <span className="flex align-items-center">
                  <TiTick className="sub-icon" />
                  Lightning-fast results:
                </span>
                <span className="sub-desc">
                  Get your appraisal in record time
                </span>
              </p>

              <p className="flex flex-col md:flex-row content-start md:items-center gap-1 sub-headd">
                <span className="flex align-items-center">
                  <TiTick className="sub-icon" />
                  Budget-friendly pricing:
                </span>
                <span className="sub-desc">
                  Competitive rates for all budget sizes
                </span>
              </p>

              <p className="flex flex-col md:flex-row content-start md:items-center gap-1 sub-headd">
                <span className="flex align-items-center">
                  <TiTick className="sub-icon" />
                  Practically validated:
                </span>
                <span className="sub-desc">
                  Methodology built on market trends and proven algorithms
                </span>
              </p>
            </div>
            <Link to="/marketplace-help" className="mt-[24px] mr-auto">
              <button className="!w-fit white-btn !border-[#fae441]">
                CONTACT US
              </button>
            </Link>
          </div>
          <div className="lg:w-[47%] w-full explore-image">
            <img src={image} alt="" className="appraisal-hero-img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreCard;
